"use strict";exports.getUppercaseRegex=e=>e?new RegExp(".*[A-Z]{".concat(e,",}")):void 0;
